import React from 'react';
import { styled } from 'linaria/react';
import { Gallery360 } from './Gallery360';

const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
  position: relative;
`;

export default function ImageContainerNew({ images, variant, ...rest }) {
  return (
    <Wrapper {...rest}>
      <div style={{ position: 'relative' }}>
        <Gallery360
          mediaList={images}
          aspect={'1:1'}
          variant={variant}
        ></Gallery360>
      </div>
    </Wrapper>
  );
}
